export default __webpack_public_path__ + "static/media/oops.7777d71f.png";